(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderMediaChange = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.onHeaderMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMediaQuery?.removeEventListener('change', this.onHeaderMediaChange);
      this.headerMediaQuery = null;
      this.onHeaderMediaChange = null;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderMediaChange = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.onHeaderMediaChange);
    }

    disconnectedCallback() {
      this.headerMediaQuery?.removeEventListener('change', this.onHeaderMediaChange);
      this.headerMediaQuery = null;
      this.onHeaderMediaChange = null;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  function initDesktopHoverMenus(scope = document) {
    const header = scope.querySelector('.header[data-desktop-menu-trigger]');
    if (!header || header.dataset.desktopHoverReady === 'true') return;

    const supportsDesktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const detailsMenus = header.querySelectorAll(
      '.header__inline-menu header-menu > details, .header__compact-menu header-menu > details'
    );

    function hoverEnabled() {
      return header.dataset.desktopMenuTrigger === 'hover' && supportsDesktopHover.matches;
    }

    function setExpanded(details, expanded) {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function closeOtherMenus(currentDetails) {
      detailsMenus.forEach((details) => {
        if (details !== currentDetails) {
          details.removeAttribute('open');
          setExpanded(details, false);
        }
      });
    }

    detailsMenus.forEach((details) => {
      let closeTimer;
      const summary = details.querySelector('summary');

      setExpanded(details, details.open);
      details.addEventListener('toggle', () => setExpanded(details, details.open));

      if (summary) {
        summary.addEventListener('click', (event) => {
          if (hoverEnabled() && details.open) {
            event.preventDefault();
            setExpanded(details, true);
          }
        });
      }

      details.addEventListener('mouseenter', () => {
        if (!hoverEnabled()) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus(details);
        details.setAttribute('open', '');
        setExpanded(details, true);
      });

      details.addEventListener('mouseleave', () => {
        if (!hoverEnabled()) return;
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            details.removeAttribute('open');
            setExpanded(details, false);
          }
        }, 180);
      });

      details.addEventListener('focusin', () => {
        if (!hoverEnabled()) return;
        closeOtherMenus(details);
        details.setAttribute('open', '');
        setExpanded(details, true);
      });
    });

    header.dataset.desktopHoverReady = 'true';
  }

  initDesktopHoverMenus();
  document.addEventListener('shopify:section:load', (event) => initDesktopHoverMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-story-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-home-story-video]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const video = section.querySelector('video');
      const toggle = section.querySelector('[data-home-story-toggle]');
      const toggleText = toggle?.querySelector('[data-home-story-toggle-text]');
      const playLabel = toggle?.dataset.playLabel || 'Play video';
      const pauseLabel = toggle?.dataset.pauseLabel || 'Pause video';
      const shouldAutoplay = section.dataset.autoplay === 'true';
      const deferAutoplay = section.dataset.deferAutoplay === 'true';
      if (!video) return;

      let autoplayIsVisible = !deferAutoplay;
      let autoplayRequested = false;
      let hasStarted = false;
      let autoplayObserver;

      const hasPlayableSource = () => Boolean(video.currentSrc || video.querySelector('source[src]'));

      const requestAutoplay = () => {
        if (!shouldAutoplay || !autoplayIsVisible || !hasPlayableSource() || autoplayRequested) return;
        autoplayRequested = true;
        if (!video.currentSrc) video.load();
        video.play().catch(() => {
          autoplayRequested = false;
        });
      };

      const updateAutoplayVisibility = (isVisible) => {
        autoplayIsVisible = isVisible;
        if (isVisible) requestAutoplay();
      };

      const observeAutoplay = () => {
        if (!shouldAutoplay || !deferAutoplay) return;

        if (!('IntersectionObserver' in window)) {
          const bounds = video.getBoundingClientRect();
          updateAutoplayVisibility(bounds.bottom > 0 && bounds.top < window.innerHeight);
          return;
        }

        autoplayObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === video) updateAutoplayVisibility(entry.isIntersecting);
          });
        });
        autoplayObserver.observe(video);
      };

      const updateState = () => {
        const isPlaying = !video.paused && !video.ended;
        if (isPlaying) hasStarted = true;
        section.classList.toggle('is-playing', isPlaying);
        section.classList.toggle('has-started', hasStarted);
        if (toggle) {
          const label = isPlaying ? pauseLabel : playLabel;
          toggle.setAttribute('aria-label', label);
          toggle.setAttribute('aria-pressed', String(isPlaying));
          if (toggleText) toggleText.textContent = label;
        }
      };

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (video.paused) {
            if (!video.currentSrc && hasPlayableSource()) video.load();
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      video.addEventListener('play', updateState);
      video.addEventListener('pause', updateState);
      video.addEventListener('ended', updateState);
      video.addEventListener('loadstart', requestAutoplay);
      video.addEventListener('loadeddata', requestAutoplay);

      observeAutoplay();
      requestAutoplay();

      updateState();

      const onSectionUnload = (event) => {
        if (event.target !== section) return;
        autoplayObserver?.disconnect();
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
      document.addEventListener('shopify:section:unload', onSectionUnload);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  function enhanceShopwoodlyPages(scope) {
    var pages = scope.querySelectorAll ? scope.querySelectorAll('[data-sw-info-page]') : [];

    pages.forEach(function (root) {
      if (root.dataset.swReady === 'true') return;

      var content = root.querySelector('[data-sw-page-content]');
      var index = root.querySelector('[data-sw-page-index]');
      var indexList = root.querySelector('[data-sw-page-index-list]');
      var mode = root.dataset.swMode;

      if (content) {
        var sourceNodes = Array.from(content.children);
        var seenHeadings = new Set();
        var removeDuplicate = false;

        if (root.dataset.swDeduplicate === 'true') {
          sourceNodes.forEach(function (node) {
            if (node.tagName === 'H2') {
              var headingKey = (node.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
              removeDuplicate = seenHeadings.has(headingKey);
              if (!removeDuplicate) seenHeadings.add(headingKey);
            }
            if (removeDuplicate) node.remove();
          });
        }

        var remainingNodes = Array.from(content.children);
        var introduction = document.createElement('div');
        var chapters = document.createElement('div');
        var currentContainer = introduction;
        var chapterHeadings = [];

        introduction.className = 'sw-brand-page__introduction sw-info-page__reveal';
        chapters.className = mode === 'faq' ? 'sw-brand-page__faq-list' : 'sw-brand-page__chapters';

        remainingNodes.forEach(function (node) {
          if (node.tagName === 'H2') {
            var chapterNumber = chapterHeadings.length + 1;
            var chapterId = root.id + '-section-' + chapterNumber;
            var headingText = (node.textContent || '').trim();
            chapterHeadings.push({ id: chapterId, text: headingText });

            if (mode === 'faq') {
              var details = document.createElement('details');
              var summary = document.createElement('summary');
              var answer = document.createElement('div');
              var mark = document.createElement('span');

              details.id = chapterId;
              details.className = 'sw-info-page__faq-item sw-info-page__reveal';
              summary.append(document.createElement('span'), mark);
              summary.firstElementChild.textContent = headingText;
              mark.className = 'sw-info-page__faq-mark';
              mark.setAttribute('aria-hidden', 'true');
              answer.className = 'sw-info-page__faq-answer rte';
              details.append(summary, answer);
              chapters.appendChild(details);
              currentContainer = answer;
              node.remove();
            } else {
              var chapter = document.createElement('section');
              node.id = chapterId + '-title';
              chapter.id = chapterId;
              chapter.className = 'sw-brand-page__chapter sw-info-page__reveal';
              chapter.setAttribute('aria-labelledby', node.id);
              chapter.appendChild(node);
              chapters.appendChild(chapter);
              currentContainer = chapter;
            }
          } else {
            currentContainer.appendChild(node);
          }
        });

        content.replaceChildren();
        if (introduction.children.length) content.appendChild(introduction);
        if (chapters.children.length) content.appendChild(chapters);

        if (index && indexList && indexList.children.length === 0 && chapterHeadings.length > 1) {
          chapterHeadings.forEach(function (heading, position) {
            var item = document.createElement('li');
            var link = document.createElement('a');
            var number = document.createElement('span');
            number.textContent = String(position + 1).padStart(2, '0');
            number.setAttribute('aria-hidden', 'true');
            link.href = '#' + heading.id;
            link.append(number, document.createTextNode(heading.text));
            item.appendChild(link);
            indexList.appendChild(item);
          });
          index.hidden = false;
        }
      }

      var revealItems = root.querySelectorAll('.sw-info-page__reveal');
      if (root.dataset.swAnimate === 'true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        revealItems.forEach(function (item) { observer.observe(item); });
      } else {
        revealItems.forEach(function (item) { item.classList.add('is-visible'); });
      }

      root.dataset.swReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceShopwoodlyPages(document); }, { once: true });
  } else {
    enhanceShopwoodlyPages(document);
  }

  document.addEventListener('shopify:section:load', function (event) { enhanceShopwoodlyPages(event.target); });

  } catch(e) { console.error(e); }
})();
})();
